import { Controller } from '@hotwired/stimulus';
import ApexCharts from 'apexcharts';

export default class extends Controller {
    connect() {
        const language = document.documentElement.lang;
        const lng = require(`apexcharts/dist/locales/${language}.json`);
        const config = JSON.parse(this.element.dataset.config);
        config.chart.locales = [lng];
        config.chart.defaultLocale = language;

        this.chart = new ApexCharts(this.element, config);
        this.chart.render();
    }

    initChart() {
        this.chart = new ApexCharts(this.element, JSON.parse(this.element.dataset.config));
        this.chart.render();
    }

    disconnect() {
        this.chart.destroy();
        super.disconnect();
    }
}
